import {RouteConfig} from "vue-router";


const prefix = '/wicare'
const wicareRoutes: Array<RouteConfig> = [
    {
        path: "/",
        name: "wicare-download",
        component: import("@/views/Wicare/wicareDownload.vue"),
        meta: {requiredRoles: ['ROLE_PRODUCTEUR']},
    },
    {
        path: '/dashboard',
        name: 'wicare-index',
        component: () => import("@/views/Wicare/wicareDashboard.vue"),
        meta: {requiredRoles: ['ROLE_PRODUCTEUR']},
    },
    {
        path: '/invitations',
        name: 'wicare-invitation',
        component: () => import("@/views/Wicare/customer/CustomerInvitation.vue"),
        meta: {requiredRoles: ['ROLE_PRODUCTEUR']},
    },
    {
        path: '/customers',
        name: 'wicare-customer-list',
        component: () => import("@/views/Wicare/customer/customerList.vue"),
        meta: {requiredRoles: ['ROLE_PRODUCTEUR']},
    },
    {
        path: '/notifications',
        name: 'wicare-notifications',
        component: () => import("@/views/Wicare/wicareNotifications.vue"),
        meta: {requiredRoles: ['ROLE_PRODUCTEUR']},
    },
    {
        path: '/parameters',
        name: 'wicare-parameters',
        component: () => import("@/views/Wicare/wicareParameters.vue"),
        meta: {requiredRoles: ['ROLE_PRODUCTEUR']},
    },


]
wicareRoutes.forEach((route) => {
    route.path = prefix + route.path
})
export default wicareRoutes;
